module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp1_7042.3b5cbfe7.png";